export const LoginCenterIcon = (props: any) => {
  return (
    <div {...props}>
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse cx="32" cy="32" rx="32" ry="32" fill="#663CEE" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7773 18.8842C17.7773 16.2005 19.9529 14.0249 22.6366 14.0249H41.3625C44.0462 14.0249 46.2217 16.2005 46.2217 18.8842C46.2217 21.5678 44.0462 23.7434 41.3625 23.7434H22.6366C19.9529 23.7434 17.7773 21.5678 17.7773 18.8842ZM26.6662 31.8026C26.6662 29.1189 28.8418 26.9434 31.5255 26.9434H41.3625C44.0462 26.9434 46.2217 29.1189 46.2217 31.8026C46.2217 34.4863 44.0462 36.6619 41.3625 36.6619H31.5255C28.8418 36.6619 26.6662 34.4863 26.6662 31.8026ZM22.6366 39.8619C19.9529 39.8619 17.7774 42.0375 17.7774 44.7211C17.7774 47.4048 19.9529 49.5804 22.6366 49.5804H41.3625C44.0462 49.5804 46.2217 47.4048 46.2217 44.7211C46.2217 42.0375 44.0462 39.8619 41.3625 39.8619H22.6366Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
